export { default } from "./TooltipIcon";
